export const staffData = [
    {
        name: "Lilly",
        role: "Owner/Director II",
        category: "Admin",
        language: "English",
        credentials: [
            { state_req: " Director II certification", staff_cred: " Meets Director I education requirements plus an additional 2 college credits or 3 CEU’s in other administration topics" },
            { state_req: " No additional work experience requirements for Director II", staff_cred: " Over 40 years of teaching experience" }
        ],
        img: <img className="staff-page-img rounded-circle w-100" src="staff_images/Lilly.jpg" alt="Lilly"/>
    },
    {
        name: "Melissa",
        role: "Preschool Teacher",
        category: "Preschool",
        language: "English",
        credentials: [
            { state_req: " Director I certification", staff_cred: " Meets the requirement for Lead Teacher plus an additional 3 college credits or 4 CEUs in Child Care Administration" },
            { state_req: " Meets work experience requirements of a Lead Teacher plus 6 additional months", staff_cred: " 25+ years teaching experience" }
        ],
        img: <img className="staff-page-img rounded-circle w-100" src="staff_images/Melissa.jpg" alt="Melissa"/>
    },
    {
        name: "Lu",
        role: "Preschool Teacher",
        category: "Preschool",
        language: "English, Ukranian, Russian",
        credentials: [
            { state_req: " Preschool Lead Teacher Certification", staff_cred: " 12 total Early Childhood Education ECE Credits" },
            { state_req: " 36 months of experience with a high school diploma or G.E.D.", staff_cred: " 7 years teaching experience" }
        ],
        img: <img className="staff-page-img rounded-circle w-100" src="staff_images/Lu.jpg" alt="Lu"/>
    },
    {
        name: "Ruby",
        role: "Preschool Teacher",
        category: "Preschool",
        language: "English, Spanish",
        credentials: [
            { state_req: " Infant/Toddler Lead Teacher Certification", staff_cred: " Associates in Early Childhood Education" },
            { state_req: " 36 months of experience with a high school diploma or G.E.D.", staff_cred: " 7 years teaching experience" }
        ],
        img: <img className="staff-page-img rounded-circle w-100" src="staff_images/Ruby.jpg" alt="Ruby"/>
    },
    {
        name: "Becky",
        role: "Floater",
        category: "Floater",
        language: "English",
        credentials: [
            { state_req: " Director I certification", staff_cred: " Meets the requirement for Lead Teacher plus an additional 3 college credits or 4 CEUs in Child Care Administration" },
            { state_req: " Meets work experience requirements of a Lead Teacher plus 6 additional months", staff_cred: " 15+ years teaching experience" }
        ],
        img: <img className="staff-page-img rounded-circle w-100" src="staff_images/Becky.jpg" alt="Becky"/>
    },
    {
        name: "Nina",
        role: "Toddler Teacher",
        category: "Toddler",
        language: "English",
        credentials: [
            { state_req: " Infant/Toddler or Preschool Teacher Certification", staff_cred: " Graduated from Lower Pioneer Valley Educational Collaborative in Early Education and Care Program" },
            { state_req: " 9 months of supervised work experience", staff_cred: " 4 years teaching experience" }
        ],
        img: <img className="staff-page-img rounded-circle w-100" src="staff_images/Nina.jpeg" alt="Nina"/>
    },
    {
        name: "Allie",
        role: "Toddler Teacher",
        category: "Toddler",
        language: "English",
        credentials: [
            { state_req: " Infant/Toddler or Preschool Teacher Certification", staff_cred: " BA in History and working towards BA in Psychology" },
            { state_req: " 9 months of supervised work experience", staff_cred: " 6 years teaching experience" }
        ],
        img: <img className="staff-page-img rounded-circle w-100" src="staff_images/Allie.jpg" alt="Allie"/>
    },
   
    {
        name: "Virgen",
        role: "Infant Teacher",
        category: "Infant",
        language: "English, Spanish",
        credentials: [
            { state_req: " Infant/Toddler Lead Teacher Certification", staff_cred: " BA in Early Childhood Education" },
            { state_req: " 36 months of experience with a high school diploma or G.E.D.", staff_cred: " 12 years teaching experience" }
        ],
        img: <img className="staff-page-img rounded-circle w-100" src="staff_images/Virgen.jpg" alt="Virgen"/>
    },
    {
        name: "Sarah",
        role: "Preschool Teacher",
        category: "Preschool",
        language: "English, Akan, Ga-Adangme",
        credentials: [
            { state_req: " Infant/Toddler Lead Teacher Certification", staff_cred: " BA in Early Childhood Education" },
            { state_req: " 36 months of experience with a high school diploma or G.E.D.", staff_cred: " 10+ years teaching experience" }
        ],
        img: <img className="staff-page-img rounded-circle w-100" src="staff_images/Sarah.jpg" alt="Sarah"/>
    },
    {
        name: "Yami",
        role: "Floater",
        category: "Floater",
        language: "English, Spanish",
        credentials: [
            { state_req: " Infant/Toddler or Preschool Teacher Certification", staff_cred: " Working towards Associates in Early Childhood Education" },
            { state_req: " 9 months of supervised work experience", staff_cred: " 5 years teaching experience" }
        ],
        img: <img className="staff-page-img rounded-circle w-100" src="staff_images/Yami.jpg" alt="Yami"/>
    },
    {
        name: "McKayla",
        role: "Toddler Teacher",
        category: "Toddler",
        language: "English",
        credentials: [
            { state_req: " Infant/Toddler Teacher Certification", staff_cred: " Infant/Toddler CDA" },
            { state_req: " 9 months of supervised work experience", staff_cred: " 3 years teaching experience" }
        ],
        img: <img className="staff-page-img rounded-circle w-100" src="staff_images/McKayla.jpg" alt="McKayla"/>
    },
    {
        name: "Nicole",
        role: "Infant Teacher",
        category: "Infant",
        language: "English",
        credentials: [
            { state_req: " Infant/Toddler Teacher Certification", staff_cred: " Working towards BA in Early Childhood Education" },
            { state_req: " 9 months of supervised work experience", staff_cred: " " }
        ],
        img: <img className="staff-page-img rounded-circle w-100" src="staff_images/Nicole.jpg" alt="Nicole"/>
    },
    {
        name: "Zuleyma",
        role: "Floater",
        category: "Floater",
        language: "English, Spanish",
        credentials: [
            { state_req: " Infant/Toddler or Preschool Teacher Certification", staff_cred: " Graduated from Lower Pioneer Valley Educational Collaborative in Early Education and Care Program" },
            { state_req: " 9 months of supervised work experience", staff_cred: " 4 years teaching experience" }
        ],
        img: <img className="staff-page-img rounded-circle w-100" src="staff_images/Zuleyma.jpeg" alt="Zuleyma"/>
    }
]
